import { useLayoutContext } from '../context/layoutContext'
import { canPersonaEditConfiguration } from './types'

export const useIsPersonaEditor = () => {
  const { persona } = useLayoutContext()
  return canPersonaEditConfiguration(persona)
}
